import { create } from "zustand";
import { CommitmentEventsAccordionState } from "./types";

const useCommitmentEventsAccordionStore = create<CommitmentEventsAccordionState>(
    (set, get) => ({
        accordions: [],
        isOpen: (id: string) => {
            const accords = get().accordions;
            // Retorna true se o id específico está aberto OU se 'all' está aberto
            return accords.includes(id) || accords.includes('all');
        },
        openAccordion: (id: string) =>
            set((state) => {
                // Se já está aberto, não faz nada
                if (state.accordions.includes(id)) return state;

                // Se abrindo 'all', adiciona apenas 'all' (remove outros se necessário)
                if (id === 'all') {
                    return { accordions: ['all'] };
                }

                // Para outros ids, adiciona normalmente (mas remove 'all' se existir)
                const accordionsWithoutAll = state.accordions.filter((item) => item !== 'all');
                return { accordions: [...accordionsWithoutAll, id] };
            }),
        closeAccordion: (id: string) =>
            set((state) => {
                // Se fechando 'all', remove apenas 'all'
                if (id === 'all') {
                    return {
                        accordions: state.accordions.filter((item) => item !== 'all'),
                    };
                }
                // Caso contrário, remove o id específico
                return {
                    accordions: state.accordions.filter((item) => item !== id),
                };
            }),
        toggleAccordion: (id: string) =>
            get().isOpen(id) ? get().closeAccordion(id) : get().openAccordion(id),
        expandAll: () => set({ accordions: ['all'] }),
        collapseAll: () => set({ accordions: [] }),
        reset: () => set({ accordions: [] }),
    })
);

export { useCommitmentEventsAccordionStore };
